import getSnippetInstance from '../zend-desk/get-snippet-instance';

const showContactForm = async () => {
  const widget = await getSnippetInstance();

  widget.showContactForm();
};

export default showContactForm;
